// extracted by mini-css-extract-plugin
export default {"wrapper":"spin_wrapper__HjiFd","loadingWrapper":"spin_loadingWrapper__-6jgU"};